<style src="./style.scss">
</style>

<script lang="ts">
  import Icon from "svelte-icon";
  import { navigate, useLocation } from "svelte-navigator";

  import AccountIcon from "@assets/icons/account.svg";
  import MessageIcon from "@assets/icons/message.svg";
  import OpenLinkIcon from "@assets/icons/open-link.svg";
  import SmartphoneIcon from "@assets/icons/smartphone.svg";
  import MenuIcon from "@assets/icons/menu.svg";
  import CloseIcon from "@assets/icons/close.svg";

  import { getToken, removeToken } from "@services/auth";
  import { getEmail } from "@services/auth";
  import { TERMS_LINK, PRIVACITY_LINK } from "@utils";

  export let hideUnsubiscribeOption = false;
  export let state = null;
  export let promotionCode = null;
  export let billingProvider = null;
  export let currentPage = "";

  const whiteListPromotionCodes = ["DCB-DIRECT-CARRIER-BILLING"];

  const location = useLocation();

  let email = getEmail();
  let isOpen = false;

  function logout() {
    removeToken();

    navigate("/auth");
  }

  const data = [
    {
      name: "Conta",
      icon: AccountIcon,
      type: "section",
      items: [
        {
          name: "Visão Geral",
          type: "page",
          route: "/overview",
        },
        {
          name: "Dados da conta",
          type: "page",
          route: "/account",
        },
        {
          name: "Cancelar assinatura",
          type: "page",
          route: "/unsubscribe",
          hide: hideUnsubiscribeOption,
        },
      ],
    },
    {
      name: "Sobre",
      icon: SmartphoneIcon,
      type: "section",
      items: [
        {
          name: "Baixar app",
          type: "link",
          source: "https://cnago.com.br/downloads",
        },
        { name: "Termos", type: "link", source: TERMS_LINK },
        {
          name: "Privacidade",
          type: "link",
          source: PRIVACITY_LINK,
        },
      ],
    },
    {
      name: "Contatos",
      icon: MessageIcon,
      type: "section",
      items: [
        { name: "Ajuda", type: "link", source: "https://help.cnago.com.br" },
      ],
    },
    {
      name: "Finalizar sessão",
      type: "action",
      action: () => logout(),
      item: { name: email },
    },
  ];

  function goTo(route: string) {
    if (route === "/unsubscribe") {
      if (
        whiteListPromotionCodes.some((value) => value === promotionCode) ||
        billingProvider === "APPLE_STORE"
      ) {
        window.open(
          "https://help.cnago.com.br/como-cancelar-a-assinatura",
          "_blank"
        );

        return;
      }
    }

    navigate(route, { state });
  }

  function toogleMenu() {
    isOpen = !isOpen;
  }
</script>

<div>
  <div class="menu-icon" on:click="{toogleMenu}">
    {#if !isOpen}
      <Icon
        data="{MenuIcon}"
        size="24px"
        stroke="transparent"
        fill="transparent" />
    {/if}

    {#if isOpen}
      <Icon
        data="{CloseIcon}"
        size="24px"
        stroke="transparent"
        fill="transparent" />
    {/if}
  </div>

  <div class="{`sidebar  ${isOpen ? 'open-menu' : ''}`}">
    {#each data as section}
      <div
        class="{`sidebar__section ${
          section.type === 'action' ? 'action-section' : ''
        }`}">
        <div class="sidebar__section__name">
          {#if section.icon}
            <Icon
              data="{section.icon}"
              size="16px"
              stroke="transparent"
              fill="transparent" />
          {/if}

          {#if section.type === "section"}
            {section.name}
          {/if}

          {#if section.type === "action"}
            <div on:click="{section.action}">
              {section.name}
            </div>
          {/if}
        </div>

        {#if section.items}
          {#each section.items as item}
            {#if !item.hide}
              <div
                class="{`sidebar__section__item ${
                  currentPage === item.route ? 'selected-section' : ''
                }`}">
                {#if item.type === "link"}
                  <a href="{item.source}" target="_blank">
                    {item.name}
                    <Icon
                      data="{OpenLinkIcon}"
                      size="16px"
                      stroke="transparent"
                      fill="transparent" />
                  </a>
                {:else}
                  <div on:click="{() => goTo(item.route)}">
                    {item.name}
                  </div>
                {/if}
              </div>
            {/if}
          {/each}
        {/if}

        {#if section.item}
          {#if section.type === "action"}
            <div on:click="{section.action}">
              {section.item.name}
            </div>
          {:else}
            <div class="sidebar__section__item">
              {section.item.name}
            </div>
          {/if}
        {/if}
      </div>
    {/each}
  </div>
</div>
